export enum PointsType {
  EXTRA = 'extra',
  POINT = 'point',
}

export const POINTS_LIMIT = 7;
